import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { LoadingComponent } from '../basic/loading/loading.component';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  component;

  constructor(
    private dialog: MatDialog,
  ) { }

  show() {
    this.component = this.dialog.open(LoadingComponent, { disableClose: true });
  }

  hide() {
    this.component.close();
  }

}
